<template>

    <div class="container card p-5 shadow col-md-5 m-auto">
        
        <h1>Reorder Steps for Category {{currentCategory.title}}</h1>
        <hr>
        <div v-if="response.success != null" v-bind:class="{ 'alert-success': response.success, 'alert-danger': !response.success }" class="alert" role="alert">
            {{response.message}}
        </div>

        <ul>
            <li>Move the pointer to the desired Category Step in the list</li>
            <li>Press, and hold down, the button on the mouse to "grab" the desired Category Step</li>
            <li>"Drag" the Category Step to the desired location by moving the pointer to this one</li>
            <li>"Drop" the Category Step by releasing the button</li>
        </ul>
        

        
        <draggable 
            :list="categorySteps" 
            v-bind="dragOptions"
            class="list-group mb-3"
            ghost-class="ghost"
            tag="ul"
            >
            <transition-group type="transition" name="flip-list">
                <li class="list-group-item" v-for="element in categorySteps" :key="element.id">
                    <i
                        :class=" element.fixed ? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'"
                        @click="element.fixed = !element.fixed"
                        aria-hidden="true"
                    ></i>
                    {{element.title}} 
                    <icon style="float: right;" icon="arrows-alt" />
                </li>
        
            </transition-group>
        </draggable>

        
        <button @click="reorderCategorySteps()" type="button" class="btn btn-primary mb-3">Reorder CategorySteps</button>
        
    </div>

</template>

<script>
import draggable from 'vuedraggable';
export default {
    data() {
        return {
            currentCategory: {},
            categorySteps: [],
            response: {}
        }
    },
    methods: {
        loadCategorySteps: function() {
            let self = this;
            this.$http.get('/api/category-steps/get-all-per-category/' + this.$route.params.categoryId)
            .then(response => {
                self.categorySteps = response.data;
            })
            .catch(error => {
                console.log(error);
            })
        },
        loadCurrentCategory: function() {
            let self = this;
            this.$http.get('/api/categories/get/' + this.$route.params.categoryId)
            .then(response => {
                self.currentCategory = response.data;
                
            })
            .catch(error => {
                console.log(error);
                self.$router.push("/404");
            })
        },
        reorderCategorySteps: function() {
            let self = this;
            this.$http.put('/api/category-steps/reorder', this.categorySteps)
            .then(response => {
                
                self.response = response.data;
            })
            .catch(error => {
                console.log(error);
            })
        },
    },
    mounted: function() {
        this.loadCurrentCategory();
        this.loadCategorySteps();
    },
    watch: {
        response: function(val){
            if(val.success === true)
            {
                setTimeout(() => {this.$router.push(`/admin/categories/${this.$route.params.categoryId}/steps/`);}, 1000)
            }
            setTimeout(() => {this.response.success = null}, 3000)
        }
    },
    components: {
            draggable,
    },
    computed: {
        dragOptions() {
            return {
                animation: 0,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        }
    }
}
</script>

<style lang="scss" scoped>
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
</style>